import { createStore as _createStore, Store } from 'vuex';

import brand from '@/js/store/modules/brand';
import complete from '@/js/store/modules/complete';
import job from '@/js/store/modules/job';
import recruiter from '@/js/store/modules/recruiter';
import register from '@/js/store/modules/register';

import resumeShop from './modules/resume-shop';
import State from './state';

let store: Store<State>;

export default function createStore() {
  if (!store) {
    store = _createStore({
      strict: process.env.NODE_ENV !== 'production',
      modules: {
        recruiter,
        register,
        brand,
        complete,
        resumeShop,
        job,
      },
    });
  }

  return store;
}
